import React from "react";

interface IChangePasswordProps {}

const ChangePassword = (props: IChangePasswordProps) => {
  return <h1>servus</h1>;
};

export default ChangePassword;
